export const hamburgerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12H20"
        stroke="#3D3D3D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 6H20"
        stroke="#3D3D3D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 18H20"
        stroke="#3D3D3D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const aircraftPartIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 3.70251L12.375 7.56501"
        stroke="#3C3C3C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 6.49999C15.7497 6.23694 15.6803 5.9786 15.5487 5.75086C15.417 5.52312 15.2278 5.33401 15 5.20249L9.75 2.20249C9.52197 2.07084 9.2633 2.00153 9 2.00153C8.7367 2.00153 8.47803 2.07084 8.25 2.20249L3 5.20249C2.7722 5.33401 2.58299 5.52312 2.45135 5.75086C2.31971 5.9786 2.25027 6.23694 2.25 6.49999V12.5C2.25027 12.763 2.31971 13.0214 2.45135 13.2491C2.58299 13.4769 2.7722 13.666 3 13.7975L8.25 16.7975C8.47803 16.9291 8.7367 16.9985 9 16.9985C9.2633 16.9985 9.52197 16.9291 9.75 16.7975L15 13.7975C15.2278 13.666 15.417 13.4769 15.5487 13.2491C15.6803 13.0214 15.7497 12.763 15.75 12.5V6.49999Z"
        stroke="#3C3C3C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.4751 5.75L9.0001 9.5L15.5251 5.75"
        stroke="#3C3C3C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 17V9.5"
        stroke="#3C3C3C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const locationIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3334 6.66665C13.3334 9.99531 9.64075 13.462 8.40075 14.5326C8.28523 14.6195 8.14461 14.6665 8.00008 14.6665C7.85555 14.6665 7.71493 14.6195 7.59941 14.5326C6.35941 13.462 2.66675 9.99531 2.66675 6.66665C2.66675 5.25216 3.22865 3.8956 4.22885 2.89541C5.22904 1.89522 6.58559 1.33331 8.00008 1.33331C9.41457 1.33331 10.7711 1.89522 11.7713 2.89541C12.7715 3.8956 13.3334 5.25216 13.3334 6.66665Z"
        stroke="#3C3C3C"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 8.66669C9.10457 8.66669 10 7.77126 10 6.66669C10 5.56212 9.10457 4.66669 8 4.66669C6.89543 4.66669 6 5.56212 6 6.66669C6 7.77126 6.89543 8.66669 8 8.66669Z"
        stroke="#3C3C3C"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const planeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8667 12.8L10.6667 7.33333L13 5C14 4 14.3333 2.66667 14 2C13.3333 1.66667 12 2 11 3L8.66667 5.33333L3.2 4.13333C2.86667 4.06667 2.6 4.2 2.46667 4.46667L2.26667 4.8C2.13333 5.13333 2.2 5.46667 2.46667 5.66667L6 8L4.66667 10H2.66667L2 10.6667L4 12L5.33333 14L6 13.3333V11.3333L8 10L10.3333 13.5333C10.5333 13.8 10.8667 13.8667 11.2 13.7333L11.5333 13.6C11.8 13.4 11.9333 13.1333 11.8667 12.8Z"
        stroke="#656465"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const arrowDown = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6L8 10L12 6"
        stroke="#3C3C3C"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const arrowUp = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10L8 6L4 10"
        stroke="#3C3C3C"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const loader = () => {
  return (
    <svg
      className="h-4 w-4 shrink-0 animate-spin fill-current"
      viewBox="0 0 16 16"
    >
      <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
    </svg>
  );
};

export const failedApiIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="11" height="11" rx="5.5" stroke="#A41E1E" />
      <path
        d="M8 4L4 8"
        stroke="#841A21"
        stroke-width="1.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 4L8 8"
        stroke="#841A21"
        stroke-width="1.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const successApiIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="#1EA44F" />
      <path
        d="M4 7L6 9L10 5"
        stroke="#1EA44F"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const disabledMailIcon = () => {
  return (
    <svg
      width="13"
      height="10"
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9 0.600098H2.1C1.49249 0.600098 1 1.09258 1 1.7001V8.3001C1 8.90761 1.49249 9.4001 2.1 9.4001H10.9C11.5075 9.4001 12 8.90761 12 8.3001V1.7001C12 1.09258 11.5075 0.600098 10.9 0.600098Z"
        stroke="#808080"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 2.25L7.0665 5.385C6.8967 5.49138 6.70037 5.54781 6.5 5.54781C6.29963 5.54781 6.1033 5.49138 5.9335 5.385L1 2.25"
        stroke="#808080"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const cancelIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="#3C3C3C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#3C3C3C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const documentIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0937 8.79032L20.1421 8.85807L20.2098 8.90647L23.5 11.2569V25.4997C23.5 26.0241 23.0236 26.5 22.4997 26.5H9.5003C8.9759 26.5 8.5 26.0236 8.5 25.4997V6.50034C8.5 5.9757 8.97659 5.5 9.49942 5.5H17.7424L20.0937 8.79032Z"
        stroke="#4592FD"
      />
      <path
        d="M11.9995 20.9995H19.9991V19.9999H12.0004L11.9995 20.9995ZM11.9995 22.9997H17.999V22.0001H11.9995V22.9997ZM11.9995 15.9996V16.9992H19.9991V15.9996H11.9995ZM11.9995 18.9994H19.9991V17.9997H12.0004L11.9995 18.9994Z"
        fill="#A1C8FD"
      />
      <path
        d="M17.9995 5V9.50014C17.9995 10.3 18.6991 10.9996 19.4989 10.9996H23.999L17.9995 5Z"
        fill="#4592FD"
      />
    </svg>
  );
};

export const verticalLine = () => {
  return (
    <svg
      width="16"
      height="27"
      viewBox="0 0 16 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="8.5" y1="2.18557e-08" x2="8.5" y2="27" stroke="#3C3C3C" />
    </svg>
  );
};

export const emptyAssignmentIcon = () => {
  return (
    <svg
      width="192"
      height="174"
      viewBox="0 0 192 174"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M76.4446 140.527C113.029 140.527 142.687 110.884 142.687 74.316C142.687 37.7492 113.029 8.1062 76.4446 8.1062C39.8603 8.1062 10.2031 37.7492 10.2031 74.316C10.2031 110.884 39.8603 140.527 76.4446 140.527Z"
        fill="#01133B"
      />
      <path
        d="M34.2628 78.0905C34.4702 78.0905 34.6691 78.0081 34.8157 77.8615C34.9624 77.715 35.0448 77.5161 35.0448 77.3088C35.0448 77.1015 34.9624 76.9027 34.8157 76.7561C34.6691 76.6095 34.4702 76.5272 34.2628 76.5272C34.0554 76.5272 33.8565 76.6095 33.7098 76.7561C33.5631 76.9027 33.4808 77.1015 33.4808 77.3088C33.4808 77.5161 33.5631 77.715 33.7098 77.8615C33.8565 78.0081 34.0554 78.0905 34.2628 78.0905ZM35.123 95.1146C35.3304 95.1146 35.5293 95.0323 35.676 94.8857C35.8226 94.7391 35.905 94.5403 35.905 94.333C35.905 94.1257 35.8226 93.9269 35.676 93.7803C35.5293 93.6337 35.3304 93.5514 35.123 93.5514C34.9156 93.5514 34.7167 93.6337 34.57 93.7803C34.4234 93.9269 34.341 94.1257 34.341 94.333C34.341 94.5403 34.4234 94.7391 34.57 94.8857C34.7167 95.0323 34.9156 95.1146 35.123 95.1146ZM64.7145 74.2143C64.9427 74.2142 65.1616 74.1235 65.3229 73.9621C65.4842 73.8007 65.5748 73.5819 65.5747 73.3537C65.5746 73.1256 65.4838 72.9068 65.3224 72.7456C65.1609 72.5844 64.9419 72.4938 64.7137 72.4939C64.4854 72.494 64.2666 72.5848 64.1053 72.7461C63.9439 72.9075 63.8534 73.1264 63.8535 73.3545C63.8536 73.5827 63.9444 73.8014 64.1058 73.9626C64.2673 74.1239 64.4862 74.2144 64.7145 74.2143ZM128.543 81.5305C128.75 81.5305 128.949 81.4481 129.096 81.3016C129.242 81.155 129.325 80.9562 129.325 80.7488C129.325 80.5415 129.242 80.3427 129.096 80.1961C128.949 80.0496 128.75 79.9672 128.543 79.9672C128.335 79.9672 128.136 80.0496 127.99 80.1961C127.843 80.3427 127.761 80.5415 127.761 80.7488C127.761 80.9562 127.843 81.155 127.99 81.3016C128.136 81.4481 128.335 81.5305 128.543 81.5305ZM124.069 87.3772C124.277 87.3772 124.476 87.2948 124.622 87.1482C124.769 87.0017 124.852 86.8028 124.852 86.5955C124.852 86.3882 124.769 86.1894 124.622 86.0428C124.476 85.8962 124.277 85.8139 124.069 85.8139C123.862 85.8139 123.663 85.8962 123.517 86.0428C123.37 86.1894 123.287 86.3882 123.287 86.5955C123.287 86.8028 123.37 87.0017 123.517 87.1482C123.663 87.2948 123.862 87.3772 124.069 87.3772ZM29.1015 94.2549C29.3089 94.2549 29.5078 94.1725 29.6544 94.0259C29.8011 93.8793 29.8835 93.6805 29.8835 93.4732C29.8835 93.2659 29.8011 93.0671 29.6544 92.9205C29.5078 92.7739 29.3089 92.6916 29.1015 92.6916C28.8941 92.6916 28.6952 92.7739 28.5485 92.9205C28.4018 93.0671 28.3194 93.2659 28.3194 93.4732C28.3194 93.6805 28.4018 93.8793 28.5485 94.0259C28.6952 94.1725 28.8941 94.2549 29.1015 94.2549ZM56.2843 58.143C56.4918 58.143 56.6907 58.0606 56.8373 57.914C56.984 57.7674 57.0664 57.5686 57.0664 57.3613C57.0664 57.154 56.984 56.9552 56.8373 56.8086C56.6907 56.662 56.4918 56.5797 56.2843 56.5797C56.0769 56.5797 55.878 56.662 55.7314 56.8086C55.5847 56.9552 55.5023 57.154 55.5023 57.3613C55.5023 57.5686 55.5847 57.7674 55.7314 57.914C55.878 58.0606 56.0769 58.143 56.2843 58.143ZM29.4456 66.741C29.653 66.741 29.8519 66.6587 29.9985 66.5121C30.1452 66.3655 30.2276 66.1667 30.2276 65.9594C30.2276 65.7521 30.1452 65.5533 29.9985 65.4067C29.8519 65.2601 29.653 65.1778 29.4456 65.1778C29.2381 65.1778 29.0392 65.2601 28.8926 65.4067C28.7459 65.5533 28.6635 65.7521 28.6635 65.9594C28.6635 66.1667 28.7459 66.3655 28.8926 66.5121C29.0392 66.6587 29.2381 66.741 29.4456 66.741ZM56.8005 64.5055C57.0079 64.5055 57.2068 64.4232 57.3534 64.2766C57.5001 64.13 57.5825 63.9312 57.5825 63.7239C57.5825 63.5166 57.5001 63.3178 57.3534 63.1712C57.2068 63.0246 57.0079 62.9423 56.8005 62.9423C56.5931 62.9423 56.3942 63.0246 56.2475 63.1712C56.1008 63.3178 56.0185 63.5166 56.0185 63.7239C56.0185 63.9312 56.1008 64.13 56.2475 64.2766C56.3942 64.4232 56.5931 64.5055 56.8005 64.5055ZM48.1983 77.2315C48.4057 77.2315 48.6046 77.1491 48.7513 77.0025C48.8979 76.8559 48.9803 76.6571 48.9803 76.4498C48.9803 76.2425 48.8979 76.0437 48.7513 75.8971C48.6046 75.7505 48.4057 75.6682 48.1983 75.6682C47.9909 75.6682 47.792 75.7505 47.6453 75.8971C47.4987 76.0437 47.4163 76.2425 47.4163 76.4498C47.4163 76.6571 47.4987 76.8559 47.6453 77.0025C47.792 77.1491 47.9909 77.2315 48.1983 77.2315ZM74.865 77.4026C75.0724 77.4026 75.2714 77.3203 75.418 77.1737C75.5647 77.0271 75.6471 76.8283 75.6471 76.621C75.6471 76.4137 75.5647 76.2149 75.418 76.0683C75.2714 75.9217 75.0724 75.8394 74.865 75.8394C74.6576 75.8394 74.4587 75.9217 74.3121 76.0683C74.1654 76.2149 74.083 76.4137 74.083 76.621C74.083 76.8283 74.1654 77.0271 74.3121 77.1737C74.4587 77.3203 74.6576 77.4026 74.865 77.4026ZM68.8435 38.4456C69.0717 38.4456 69.2905 38.355 69.4518 38.1938C69.6131 38.0325 69.7037 37.8138 69.7037 37.5858C69.7037 37.3577 69.6131 37.1391 69.4518 36.9778C69.2905 36.8166 69.0717 36.726 68.8435 36.726C68.6154 36.726 68.3966 36.8166 68.2353 36.9778C68.0739 37.1391 67.9833 37.3577 67.9833 37.5858C67.9833 37.8138 68.0739 38.0325 68.2353 38.1938C68.3966 38.355 68.6154 38.4456 68.8435 38.4456ZM62.994 51.8586C63.2222 51.8586 63.441 51.768 63.6023 51.6067C63.7636 51.4455 63.8543 51.2268 63.8543 50.9988C63.8543 50.7707 63.7636 50.552 63.6023 50.3908C63.441 50.2295 63.2222 50.139 62.994 50.139C62.7659 50.139 62.5471 50.2295 62.3858 50.3908C62.2244 50.552 62.1338 50.7707 62.1338 50.9988C62.1338 51.2268 62.2244 51.4455 62.3858 51.6067C62.5471 51.768 62.7659 51.8586 62.994 51.8586ZM92.2414 43.2605C92.4696 43.2605 92.6884 43.1699 92.8497 43.0087C93.011 42.8474 93.1017 42.6287 93.1017 42.4007C93.1017 42.1727 93.011 41.954 92.8497 41.7927C92.6884 41.6315 92.4696 41.5409 92.2414 41.5409C92.0133 41.5409 91.7945 41.6315 91.6332 41.7927C91.4719 41.954 91.3812 42.1727 91.3812 42.4007C91.3812 42.6287 91.4719 42.8474 91.6332 43.0087C91.7945 43.1699 92.0133 43.2605 92.2414 43.2605ZM56.6284 50.5775C56.8358 50.5775 57.0347 50.4951 57.1814 50.3485C57.3281 50.2019 57.4104 50.0031 57.4104 49.7958C57.4104 49.5885 57.3281 49.3897 57.1814 49.2431C57.0347 49.0965 56.8358 49.0142 56.6284 49.0142C56.421 49.0142 56.2221 49.0965 56.0755 49.2431C55.9288 49.3897 55.8464 49.5885 55.8464 49.7958C55.8464 50.0031 55.9288 50.2019 56.0755 50.3485C56.2221 50.4951 56.421 50.5775 56.6284 50.5775ZM83.8113 27.1907C84.0187 27.1907 84.2176 27.1084 84.3643 26.9618C84.5109 26.8152 84.5933 26.6164 84.5933 26.4091C84.5933 26.2018 84.5109 26.003 84.3643 25.8564C84.2176 25.7098 84.0187 25.6274 83.8113 25.6274C83.6039 25.6274 83.405 25.7098 83.2583 25.8564C83.1117 26.003 83.0293 26.2018 83.0293 26.4091C83.0293 26.6164 83.1117 26.8152 83.2583 26.9618C83.405 27.1084 83.6039 27.1907 83.8113 27.1907ZM48.7144 73.6195C48.9218 73.6195 49.1207 73.5371 49.2674 73.3905C49.4141 73.244 49.4964 73.0451 49.4964 72.8378C49.4964 72.6305 49.4141 72.4317 49.2674 72.2851C49.1207 72.1386 48.9218 72.0562 48.7144 72.0562C48.507 72.0562 48.3081 72.1386 48.1615 72.2851C48.0148 72.4317 47.9324 72.6305 47.9324 72.8378C47.9324 73.0451 48.0148 73.244 48.1615 73.3905C48.3081 73.5371 48.507 73.6195 48.7144 73.6195ZM42.6929 34.6624C42.921 34.6624 43.1398 34.5718 43.3012 34.4106C43.4625 34.2494 43.5531 34.0307 43.5531 33.8026C43.5531 33.5746 43.4625 33.3559 43.3012 33.1947C43.1398 33.0334 42.921 32.9428 42.6929 32.9428C42.4648 32.9428 42.246 33.0334 42.0846 33.1947C41.9233 33.3559 41.8327 33.5746 41.8327 33.8026C41.8327 34.0307 41.9233 34.2494 42.0846 34.4106C42.246 34.5718 42.4648 34.6624 42.6929 34.6624ZM36.8434 48.0762C36.9564 48.0762 37.0683 48.0539 37.1727 48.0106C37.2771 47.9673 37.372 47.9039 37.4518 47.824C37.5317 47.7441 37.5951 47.6492 37.6383 47.5448C37.6815 47.4404 37.7037 47.3286 37.7036 47.2156C37.7036 47.1027 37.6813 46.9908 37.638 46.8865C37.5947 46.7821 37.5313 46.6873 37.4513 46.6075C37.3713 46.5276 37.2765 46.4643 37.172 46.4211C37.0676 46.378 36.9557 46.3558 36.8426 46.3558C36.6144 46.3559 36.3955 46.4466 36.2342 46.608C36.0729 46.7694 35.9823 46.9883 35.9824 47.2164C35.9825 47.4445 36.0733 47.6633 36.2348 47.8245C36.3962 47.9858 36.6152 48.0763 36.8434 48.0762ZM66.0908 39.4781C66.2038 39.4781 66.3157 39.4558 66.4201 39.4125C66.5245 39.3692 66.6194 39.3058 66.6993 39.2259C66.7791 39.146 66.8425 39.0511 66.8857 38.9468C66.9289 38.8424 66.9511 38.7305 66.951 38.6175C66.951 38.5046 66.9287 38.3927 66.8854 38.2884C66.8421 38.1841 66.7786 38.0893 66.6987 38.0094C66.6187 37.9296 66.5238 37.8663 66.4194 37.8231C66.315 37.7799 66.2031 37.7577 66.09 37.7577C65.8618 37.7578 65.6429 37.8486 65.4816 38.01C65.3203 38.1714 65.2297 38.3902 65.2298 38.6183C65.2299 38.8465 65.3207 39.0652 65.4822 39.2265C65.6436 39.3877 65.8626 39.4782 66.0908 39.4781ZM23.252 57.1112C23.4594 57.1112 23.6583 57.0289 23.805 56.8823C23.9516 56.7357 24.034 56.5369 24.034 56.3296C24.034 56.1223 23.9516 55.9234 23.805 55.7769C23.6583 55.6303 23.4594 55.5479 23.252 55.5479C23.0446 55.5479 22.8457 55.6303 22.699 55.7769C22.5524 55.9234 22.47 56.1223 22.47 56.3296C22.47 56.5369 22.5524 56.7357 22.699 56.8823C22.8457 57.0289 23.0446 57.1112 23.252 57.1112ZM57.6607 23.4068C57.8681 23.4068 58.067 23.3244 58.2137 23.1779C58.3603 23.0313 58.4427 22.8325 58.4427 22.6251C58.4427 22.4178 58.3603 22.219 58.2137 22.0724C58.067 21.9259 57.8681 21.8435 57.6607 21.8435C57.4533 21.8435 57.2544 21.9259 57.1077 22.0724C56.9611 22.219 56.8787 22.4178 56.8787 22.6251C56.8787 22.8325 56.9611 23.0313 57.1077 23.1779C57.2544 23.3244 57.4533 23.4068 57.6607 23.4068ZM56.9725 35.7888C57.1799 35.7888 57.3788 35.7064 57.5255 35.5598C57.6721 35.4133 57.7545 35.2144 57.7545 35.0071C57.7545 34.7998 57.6721 34.601 57.5255 34.4544C57.3788 34.3078 57.1799 34.2255 56.9725 34.2255C56.7651 34.2255 56.5662 34.3078 56.4195 34.4544C56.2729 34.601 56.1905 34.7998 56.1905 35.0071C56.1905 35.2144 56.2729 35.4133 56.4195 35.5598C56.5662 35.7064 56.7651 35.7888 56.9725 35.7888ZM91.2092 36.9925C91.4166 36.9925 91.6155 36.9102 91.7621 36.7636C91.9088 36.617 91.9912 36.4182 91.9912 36.2109C91.9912 36.0036 91.9088 35.8048 91.7621 35.6582C91.6155 35.5116 91.4166 35.4292 91.2092 35.4292C91.0018 35.4292 90.8029 35.5116 90.6562 35.6582C90.5096 35.8048 90.4272 36.0036 90.4272 36.2109C90.4272 36.4182 90.5096 36.617 90.6562 36.7636C90.8029 36.9102 91.0018 36.9925 91.2092 36.9925ZM75.7253 46.2784C75.9327 46.2784 76.1316 46.1961 76.2782 46.0495C76.4249 45.9029 76.5073 45.7041 76.5073 45.4968C76.5073 45.2895 76.4249 45.0907 76.2782 44.9441C76.1316 44.7975 75.9327 44.7151 75.7253 44.7151C75.5179 44.7151 75.319 44.7975 75.1723 44.9441C75.0256 45.0907 74.9432 45.2895 74.9432 45.4968C74.9432 45.7041 75.0256 45.9029 75.1723 46.0495C75.319 46.1961 75.5179 46.2784 75.7253 46.2784ZM102.392 46.4496C102.599 46.4496 102.798 46.3673 102.945 46.2207C103.092 46.0741 103.174 45.8753 103.174 45.668C103.174 45.4607 103.092 45.2618 102.945 45.1153C102.798 44.9687 102.599 44.8863 102.392 44.8863C102.185 44.8863 101.986 44.9687 101.839 45.1153C101.692 45.2618 101.61 45.4607 101.61 45.668C101.61 45.8753 101.692 46.0741 101.839 46.2207C101.986 46.3673 102.185 46.4496 102.392 46.4496Z"
        fill="white"
      />
      <path
        d="M131.669 124.049L124.34 131.374L141.645 148.672L148.975 141.346L131.669 124.049Z"
        fill="#2B70B5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M113.804 130.001L130.524 113.289L138.083 120.843C139.297 122.058 139.98 123.705 139.98 125.422C139.98 127.139 139.297 128.786 138.083 130.001L130.524 137.555C129.309 138.77 127.662 139.452 125.943 139.452C124.225 139.452 122.577 138.77 121.362 137.555L113.804 130.001Z"
        fill="#6BA3DB"
      />
      <path
        d="M144.318 137.556L138.082 143.788C133.164 148.705 133.164 156.677 138.082 161.594L164.041 187.54C168.961 192.457 176.937 192.457 181.856 187.54L188.092 181.308C193.01 176.391 193.01 168.419 188.092 163.502L162.133 137.556C157.213 132.639 149.237 132.639 144.318 137.556Z"
        fill="#183E64"
      />
      <path
        d="M122.164 121.645C148.033 95.7878 148.033 53.866 122.164 28.0092C96.2947 2.15252 54.3528 2.15252 28.4837 28.0092C2.61464 53.866 2.61464 95.7878 28.4837 121.645C54.3528 147.501 96.2947 147.501 122.164 121.645Z"
        stroke="#03B7ED"
        stroke-width="16.214"
      />
      <mask
        id="mask0_11_3738"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="16"
        y="1"
        width="152"
        height="133"
      >
        <path
          d="M75.2905 133.024C107.502 133.024 133.613 106.925 133.613 74.7295C133.613 63.8975 172.311 29.5216 167.162 20.8313C157.007 3.69226 100.677 1.302 79.3038 1.302C47.0926 1.302 16.9678 42.5344 16.9678 74.7295C16.9678 106.925 43.0801 133.024 75.2905 133.024Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_11_3738)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M150.781 33.2829C151.143 36.6919 150.281 40.1186 148.348 42.9503L118.457 86.7434L126.351 102.923C116.41 120.872 97.2698 133.025 75.2904 133.025C73.5715 133.025 71.8533 132.951 70.1409 132.801L66.8322 125.355L65.7373 132.247C54.5389 130.402 44.4165 125.37 36.3328 118.113L38.1431 99.4802C38.3622 97.2217 39.1369 95.0524 40.3982 93.1657C41.6595 91.279 43.3682 89.7335 45.3721 88.667L76.5855 72.0501L97.3144 53.984L116.443 37.4061L70.3794 38.4465L69.7749 27.7356L89.0211 25.3188L134.882 20.446C142.819 19.6019 149.937 25.3501 150.781 33.2829Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M69.8132 77.105L63.2224 61.5894L77.3949 55.5786L83.9849 71.0934"
          fill="white"
        />
        <path
          d="M69.8132 77.105L63.2224 61.5894L77.3949 55.5786L83.9849 71.0934"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <mask
          id="mask1_11_3738"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="63"
          y="55"
          width="21"
          height="25"
        >
          <path
            d="M63.2224 61.5887L77.3933 55.5786L82.9926 68.7587C84.6544 72.6716 82.8299 77.1895 78.9167 78.8489C75.0035 80.5091 70.4834 78.6824 68.8217 74.7695L63.2224 61.5887Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_11_3738)">
          <path
            d="M79.2843 64.0961C88.1243 60.3466 92.4785 50.6871 89.0103 42.5212C85.5413 34.3554 75.5635 30.7755 66.7236 34.525C57.8837 38.2754 53.5294 47.9341 56.9985 56.0999C60.4667 64.2658 70.4444 67.8457 79.2843 64.0961Z"
            fill="#01133B"
          />
        </g>
        <path
          d="M59.4961 27.4792L55.5227 29.1652C49.5004 31.7189 46.6922 38.6708 49.2502 44.6918L52.9522 53.4079C55.5102 59.4289 62.4647 62.2389 68.4862 59.6845L72.4596 57.9992C78.4811 55.4448 81.2894 48.4937 78.7322 42.4727L75.0293 33.7566C72.4721 27.7356 65.5177 24.9248 59.4961 27.4792Z"
          fill="#01133B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M76.8138 42.11L78.1628 41.276C78.5344 41.0465 78.9538 40.9053 79.3886 40.8633C79.8233 40.8213 80.262 40.8796 80.6707 41.0337C81.0794 41.1879 81.4473 41.4337 81.7459 41.7523C82.0446 42.0708 82.2662 42.4537 82.3935 42.8713L82.4318 42.9956C82.7618 44.0749 82.7578 45.2286 82.4203 46.3055C82.0829 47.3824 81.4278 48.3323 80.5409 49.0307L79.9513 49.4958L76.8138 42.11Z"
          fill="white"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M79.3037 43.675L80.2805 45.9746M79.9176 45.1203L80.6269 43.7954"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M54.1212 51.7375L52.5846 52.1284C52.1612 52.2358 51.7681 52.439 51.4357 52.7223C51.1033 53.0055 50.8404 53.3613 50.6673 53.7622C50.4942 54.163 50.4155 54.5983 50.4373 55.0344C50.4591 55.4704 50.5808 55.8957 50.793 56.2773L50.8563 56.3914C51.4039 57.3785 52.2372 58.1772 53.2468 58.6828C54.2564 59.1885 55.3953 59.3774 56.5142 59.2249L57.2587 59.1241L54.1212 51.7375Z"
          fill="white"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.5191 54.6147L54.4959 56.9143M54.1322 56.0608L52.6863 55.6504"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M75.3203 38.6037L78.7948 46.7828C81.4552 53.0461 78.5336 60.2787 72.2697 62.9355C66.0049 65.5931 58.7697 62.6689 56.1093 56.4056L52.6348 48.2265C49.9744 41.9625 52.8952 34.7307 59.1599 32.0731C65.4247 29.4163 72.6599 32.3397 75.3203 38.6037Z"
          fill="white"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M69.9493 56.7244C70.971 56.2921 71.7791 55.4717 72.1957 54.4439C72.6124 53.416 72.6035 52.2648 72.171 51.2436M65.7866 49.4966L66.5522 52.5958L68.2641 52.1917"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M59.7135 51.049C60.9475 50.5261 61.7045 49.5287 61.4042 48.8213C61.1039 48.1139 59.8597 47.9646 58.6257 48.4883C57.3917 49.012 56.6355 50.0094 56.9358 50.7168C57.2361 51.4234 58.4795 51.5727 59.7135 51.049Z"
          stroke="#01133B"
          stroke-width="0.571493"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M59.7135 51.0489C60.4541 50.7346 60.8107 49.9069 60.5104 49.1995C60.2101 48.4929 59.3663 48.174 58.6257 48.4882C57.8859 48.8024 57.5293 49.6302 57.8296 50.3368C58.1299 51.0442 58.9737 51.3631 59.7135 51.0489Z"
          fill="#01133B"
        />
        <path
          d="M72.0906 45.7987C73.3246 45.275 74.0816 44.2776 73.7813 43.5702C73.4802 42.8628 72.2368 42.7143 71.0028 43.2372C69.7688 43.7609 69.0118 44.7583 69.3121 45.4657C69.6124 46.1731 70.8565 46.3216 72.0906 45.7987Z"
          stroke="#01133B"
          stroke-width="0.571493"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M72.0905 45.7979C72.8311 45.4836 73.1877 44.6559 72.8874 43.9493C72.5871 43.2419 71.7433 42.923 71.0027 43.2372C70.2622 43.5514 69.9055 44.3792 70.2058 45.0858C70.5061 45.7932 71.3499 46.1121 72.0905 45.7979Z"
          fill="#01133B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M62.582 23.5086C64.5902 23.3351 65.7687 24.3449 66.1175 26.5359C68.5347 25.9371 70.7994 25.8387 72.9116 26.242C77.6358 27.144 79.4071 32.2513 77.0243 36.7965C77.2299 37.9182 77.4598 39.2845 77.7148 40.8947C77.0516 41.5942 76.5824 41.8959 76.3087 41.7998C75.4301 41.4876 74.5977 41.058 73.8344 40.5226C71.7058 42.1726 68.731 43.4553 64.8139 43.9845C59.1419 44.7513 55.4492 44.0197 53.7366 41.792C54.1346 45.3516 54.0267 48.4211 53.4128 50.9997C48.5409 48.2483 45.961 45.164 45.674 41.7466C45.4206 38.7319 46.6476 37.0294 49.3534 36.6378C50.0799 32.3216 57.0344 23.987 62.582 23.5086Z"
          fill="#01133B"
        />
        <path
          d="M53.4128 50.9997C48.9991 48.4 45.961 45.1632 45.674 41.7467C45.4206 38.7319 46.6476 37.0287 49.3534 36.6378C50.0807 32.3208 57.0344 23.987 62.582 23.5086C64.5894 23.3351 65.7687 24.3442 66.1175 26.5359C68.5347 25.9364 70.7994 25.8387 72.9116 26.242C77.0587 27.0338 78.1535 31.5197 76.9374 35.5678C77.2299 37.1889 77.4317 39.2259 77.7148 40.8939"
          stroke="white"
          stroke-width="0.688924"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M67.7487 130.923L64.7997 124.938"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M62.1348 84.2297L83.6136 86.9014L91.3783 67.1633"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M85.0634 13.8318L86.808 49.4184L99.8622 48.0678L88.5621 61.2994L135.507 160.928L150.443 132.658L123.725 84.7346L151.217 42.1312C157.397 32.5561 154.641 19.7825 145.064 13.5997C141.293 11.1649 136.831 10.0255 132.354 10.3543L85.0634 13.8318Z"
          fill="#EDEEF2"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linejoin="round"
        />
        <path
          d="M99.1389 48.969L106.681 39.4346"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M97.4137 51.2419L101.705 76.6203L107.976 75.3728C108.72 75.225 109.486 75.2323 110.227 75.3943C110.967 75.5563 111.667 75.8695 112.281 76.3142C112.895 76.7589 113.41 77.3256 113.795 77.9787C114.179 78.6317 114.425 79.3572 114.516 80.1096L119.955 124.938"
          fill="#EDEEF2"
        />
        <path
          d="M97.4137 51.2419L101.705 76.6203L107.976 75.3728C108.72 75.225 109.486 75.2323 110.227 75.3943C110.967 75.5563 111.667 75.8695 112.281 76.3142C112.895 76.7589 113.41 77.3256 113.795 77.9787C114.179 78.6317 114.425 79.3572 114.516 80.1096L119.955 124.938"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M61.1549 80.0603L103.08 175.496L87.5221 182.637L66.2732 139.206L63.2249 152.57L33.5802 142.13L38.0533 99.6944C38.2988 97.3627 39.1088 95.1258 40.4133 93.1772C41.7178 91.2286 43.4775 89.6269 45.5403 88.5106L61.1549 80.0603Z"
          fill="#EDEEF2"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linejoin="round"
        />
        <path
          d="M124.413 85.9571L121.432 80.749"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.8094 85.2324L66.0885 102.905L62.2503 111.943C61.8889 112.795 61.7631 113.728 61.8861 114.645C62.0091 115.562 62.3764 116.429 62.9495 117.155L93.1017 155.372"
          fill="#EDEEF2"
        />
        <path
          d="M50.8094 85.2324L66.0885 102.905L62.2503 111.943C61.8889 112.795 61.7631 113.728 61.8861 114.645C62.0091 115.562 62.3764 116.429 62.9495 117.155L93.1016 155.372"
          stroke="#01133B"
          stroke-width="1.03339"
          stroke-linejoin="round"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.2464 38.119L45.0577 41.144C43.7743 41.248 42.4997 40.8579 41.4946 40.0535C40.4895 39.2491 39.8299 38.0912 39.6508 36.8168C39.564 36.2009 39.5995 35.5739 39.7551 34.9717C39.9108 34.3695 40.1837 33.8039 40.5581 33.3071C40.9325 32.8103 41.4012 32.3922 41.9374 32.0765C42.4735 31.7608 43.0666 31.5537 43.6829 31.4672L43.704 31.4641L84.2281 25.959"
        fill="white"
      />
      <path
        d="M82.2464 38.119L45.0577 41.144C43.7743 41.248 42.4997 40.8579 41.4946 40.0535C40.4895 39.2491 39.8299 38.0912 39.6508 36.8168C39.564 36.2009 39.5995 35.5739 39.7551 34.9717C39.9108 34.3695 40.1837 33.8039 40.5581 33.3071C40.9325 32.8103 41.4012 32.3922 41.9374 32.0765C42.4735 31.7608 43.0666 31.5537 43.6829 31.4672L43.704 31.4641L84.228 25.959"
        stroke="#01133B"
        stroke-width="1.3434"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.2474 38.1182L56.1828 39.683C54.8888 39.7605 53.6132 39.3479 52.6099 38.5274C51.6066 37.707 50.9493 36.5389 50.7689 35.2558C50.6824 34.6408 50.7178 34.0149 50.8733 33.4136C51.0287 32.8123 51.3012 32.2476 51.675 31.7515C52.0488 31.2555 52.5167 30.8379 53.052 30.5227C53.5873 30.2074 54.1795 30.0006 54.7947 29.914L54.8229 29.9101L84.2283 25.9597"
        fill="white"
      />
      <path
        d="M82.2474 38.1182L56.1828 39.683C54.8888 39.7605 53.6132 39.3479 52.6099 38.5274C51.6066 37.707 50.9493 36.5389 50.7689 35.2558C50.6824 34.6408 50.7178 34.0149 50.8733 33.4136C51.0287 32.8123 51.3012 32.2476 51.675 31.7515C52.0488 31.2555 52.5167 30.8379 53.052 30.5227C53.5873 30.2074 54.1795 30.0006 54.7947 29.914L54.8229 29.9101L84.2283 25.9597"
        stroke="#01133B"
        stroke-width="1.03339"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M39.3225 112.074C39.6264 111.478 39.8099 110.827 39.8625 110.16C39.915 109.493 39.8355 108.822 39.6286 108.185C39.4217 107.549 39.0913 106.959 38.6565 106.45C38.2216 105.941 37.6907 105.523 37.0941 105.219C36.4975 104.915 35.8468 104.732 35.1793 104.68C34.5118 104.627 33.8405 104.706 33.2036 104.913C32.5668 105.12 31.977 105.45 31.4679 105.885C30.9587 106.32 30.5402 106.85 30.2362 107.447L25.1414 117.441C24.8328 118.037 24.6453 118.689 24.5896 119.359C24.534 120.028 24.6113 120.702 24.8172 121.342C25.0231 121.981 25.3534 122.574 25.7892 123.085C26.225 123.596 26.7576 124.017 27.3565 124.322C27.9553 124.627 28.6086 124.81 29.2787 124.862C29.9488 124.913 30.6226 124.832 31.2611 124.623C31.8997 124.413 32.4905 124.08 32.9996 123.641C33.5087 123.202 33.9261 122.668 34.2276 122.067L39.3225 112.074Z"
        fill="white"
        stroke="#01133B"
        stroke-width="1.03339"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48.4117 116.702C48.7271 116.105 48.9204 115.451 48.9806 114.778C49.0408 114.105 48.9665 113.427 48.7622 112.783C48.5579 112.139 48.2276 111.542 47.7905 111.027C47.3534 110.512 46.8181 110.089 46.2159 109.782C45.6138 109.475 44.9566 109.292 44.2827 109.241C43.6087 109.191 42.9315 109.274 42.2903 109.488C41.6491 109.701 41.0567 110.04 40.5476 110.484C40.0385 110.928 39.6228 111.469 39.3247 112.076L34.2299 122.07C33.9213 122.666 33.7338 123.318 33.6781 123.988C33.6225 124.657 33.6998 125.331 33.9057 125.971C34.1116 126.61 34.4419 127.203 34.8777 127.714C35.3135 128.225 35.8461 128.646 36.445 128.951C37.0438 129.256 37.6971 129.439 38.3672 129.491C39.0373 129.543 39.711 129.461 40.3496 129.252C40.9882 129.042 41.579 128.709 42.0881 128.27C42.5972 127.831 43.0146 127.297 43.3161 126.696L48.4117 116.702Z"
        fill="white"
        stroke="#01133B"
        stroke-width="1.03339"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M57.5004 121.331C57.8089 120.734 57.9965 120.082 58.0521 119.413C58.1077 118.743 58.0304 118.07 57.8245 117.43C57.6187 116.791 57.2883 116.198 56.8526 115.687C56.4168 115.175 55.8841 114.755 55.2853 114.45C54.6864 114.145 54.0331 113.962 53.363 113.91C52.6929 113.858 52.0192 113.939 51.3806 114.149C50.742 114.359 50.1512 114.692 49.6421 115.131C49.133 115.569 48.7157 116.104 48.4141 116.705L43.3185 126.699C43.0032 127.296 42.8098 127.95 42.7496 128.623C42.6895 129.296 42.7637 129.974 42.968 130.618C43.1723 131.262 43.5026 131.859 43.9397 132.374C44.3769 132.889 44.9121 133.312 45.5143 133.619C46.1165 133.925 46.7736 134.109 47.4476 134.16C48.1215 134.21 48.7987 134.126 49.4399 133.913C50.0812 133.699 50.6735 133.361 51.1826 132.917C51.6917 132.472 52.1074 131.931 52.4055 131.325L57.5004 121.331Z"
        fill="white"
        stroke="#01133B"
        stroke-width="1.03339"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M66.589 125.96C66.8975 125.363 67.0851 124.711 67.1407 124.042C67.1963 123.372 67.119 122.698 66.9131 122.059C66.7073 121.42 66.3769 120.827 65.9412 120.316C65.5054 119.804 64.9727 119.384 64.3739 119.079C63.775 118.774 63.1217 118.59 62.4516 118.539C61.7815 118.487 61.1078 118.568 60.4692 118.778C59.8306 118.987 59.2398 119.321 58.7307 119.76C58.2216 120.198 57.8043 120.733 57.5027 121.333L52.4079 131.327C52.1039 131.923 51.9204 132.573 51.8679 133.241C51.8154 133.908 51.8948 134.579 52.1017 135.215C52.3087 135.852 52.639 136.441 53.0739 136.95C53.5087 137.459 54.0396 137.877 54.6362 138.181C55.2328 138.485 55.8835 138.669 56.551 138.721C57.2185 138.774 57.8899 138.694 58.5267 138.487C59.1635 138.28 59.7533 137.95 60.2625 137.516C60.7716 137.081 61.1901 136.55 61.4941 135.954L66.589 125.96Z"
        fill="white"
        stroke="#01133B"
        stroke-width="1.03339"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const milestoneTitleIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_202_6580)">
        <path
          d="M7.99992 14.6666C11.6818 14.6666 14.6666 11.6819 14.6666 7.99998C14.6666 4.31808 11.6818 1.33331 7.99992 1.33331C4.31802 1.33331 1.33325 4.31808 1.33325 7.99998C1.33325 11.6819 4.31802 14.6666 7.99992 14.6666Z"
          stroke="#3C3C3C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 10.0001C9.10457 10.0001 10 9.10463 10 8.00006C10 6.89549 9.10457 6.00006 8 6.00006C6.89543 6.00006 6 6.89549 6 8.00006C6 9.10463 6.89543 10.0001 8 10.0001Z"
          stroke="#3C3C3C"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_202_6580">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const successPopupIcon = () => {
  return (
    <svg
      width="123"
      height="122"
      viewBox="0 0 123 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.5"
        y="8.6958"
        width="104"
        height="104"
        rx="52"
        fill="#CDF3FE"
      />
      <rect
        x="9.5"
        y="8.6958"
        width="104"
        height="104"
        rx="52"
        stroke="#EBFAFF"
        stroke-width="17.3333"
      />
      <path
        d="M51.75 60.6957L58.25 67.1957L71.25 54.1957M83.1667 60.6957C83.1667 72.6619 73.4662 82.3624 61.5 82.3624C49.5338 82.3624 39.8333 72.6619 39.8333 60.6957C39.8333 48.7295 49.5338 39.0291 61.5 39.0291C73.4662 39.0291 83.1667 48.7295 83.1667 60.6957Z"
        stroke="#03B7ED"
        stroke-width="4.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const failurePopupIcon = () => {
  return (
    <svg
      width="123"
      height="123"
      viewBox="0 0 123 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="9.5" y="9.5" width="104" height="104" rx="52" fill="#FAD1D1" />
      <rect
        x="9.5"
        y="9.5"
        width="104"
        height="104"
        rx="52"
        stroke="#FDECEC"
        stroke-width="17.3333"
      />
      <path
        d="M84.7046 76L66.038 43.3333C65.6309 42.6151 65.0407 42.0177 64.3275 41.6021C63.6142 41.1865 62.8035 40.9675 61.978 40.9675C61.1525 40.9675 60.3417 41.1865 59.6285 41.6021C58.9152 42.0177 58.325 42.6151 57.918 43.3333L39.2513 76C38.8399 76.7125 38.6242 77.5211 38.626 78.3438C38.6278 79.1666 38.8471 79.9742 39.2617 80.6849C39.6762 81.3956 40.2713 81.984 40.9866 82.3906C41.7019 82.7971 42.5119 83.0074 43.3346 83H80.668C81.4867 82.9991 82.2909 82.7829 82.9996 82.3729C83.7084 81.963 84.2968 81.3738 84.7058 80.6646C85.1148 79.9553 85.3301 79.1509 85.3298 78.3321C85.3296 77.5133 85.114 76.709 84.7046 76Z"
        stroke="#F5171B"
        stroke-width="4.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62 55V64.3333"
        stroke="#F5171B"
        stroke-width="4.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62 73.6667H62.0225"
        stroke="#F5171B"
        stroke-width="4.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const submittedSvg = () => {
  return (
    <svg
      width="265"
      height="266"
      viewBox="0 0 265 266"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M132.759 265.194C205.793 265.194 264.999 205.989 264.999 132.955C264.999 59.921 205.793 0.715332 132.759 0.715332C59.7252 0.715332 0.519531 59.921 0.519531 132.955C0.519531 205.989 59.7252 265.194 132.759 265.194Z"
        fill="url(#paint0_linear_11_4729)"
      />
      <path
        d="M264.303 149.77C249.729 143.403 230.755 140.354 218.904 144.795C207.785 148.962 209.574 157.233 198.16 160.65C179.747 166.163 166.991 147.059 139.591 147.966C115.211 148.773 106.76 164.51 88.3417 160.65C76.8552 158.243 74.6801 150.977 66.5034 145.852C52.8017 137.265 26.5016 137.354 1.21436 142.267C3.51706 175.358 17.9912 205.092 40.1937 227.026C65.1679 231.646 92.3404 234.113 118.847 233.129C165.427 231.401 212.539 218.926 244.627 204.072C254.897 188.005 261.79 169.571 264.303 149.77Z"
        fill="url(#paint1_linear_11_4729)"
      />
      <path
        d="M225.441 75.9112H193.465C191.596 75.9112 189.885 75.234 188.564 74.1113C186.929 72.7221 185.892 70.6512 185.892 68.3379C185.892 66.2468 186.74 64.3532 188.11 62.9828C189.48 61.6124 191.374 60.7646 193.465 60.7646H225.441C227.532 60.7646 229.426 61.6124 230.796 62.9828C232.167 64.3532 233.014 66.2468 233.014 68.3379C233.014 70.429 232.167 72.3226 230.796 73.693C229.426 75.0634 227.533 75.9112 225.441 75.9112Z"
        fill="#D8E2F4"
      />
      <path
        d="M217.902 65.8755C219.386 59.7145 215.596 53.5165 209.435 52.0317C203.274 50.5469 197.076 54.3376 195.591 60.4986C194.106 66.6595 197.897 72.8577 204.058 74.3425C210.219 75.8273 216.417 72.0364 217.902 65.8755Z"
        fill="#D8E2F4"
      />
      <path
        d="M77.0087 57.574H30.0818C27.0125 57.574 24.234 56.3301 22.2226 54.3187C20.2111 52.3073 18.9673 49.5288 18.9673 46.46C18.9673 44.2713 19.6001 42.2309 20.6923 40.5107C22.6636 37.4062 26.1319 35.3459 30.0818 35.3459H77.0087C80.078 35.3459 82.8561 36.5898 84.8675 38.6012C86.8789 40.6127 88.1228 43.3912 88.1228 46.46C88.1228 49.323 87.0402 51.9334 85.2621 53.9038C83.228 56.1572 80.2838 57.574 77.0087 57.574Z"
        fill="white"
      />
      <path
        d="M49.5045 55.7774C58.8047 55.7774 66.3441 48.238 66.3441 38.9378C66.3441 29.6375 58.8047 22.0981 49.5045 22.0981C40.2042 22.0981 32.6648 29.6375 32.6648 38.9378C32.6648 48.238 40.2042 55.7774 49.5045 55.7774Z"
        fill="white"
      />
      <path
        d="M229.601 235.382C229.601 236.528 190.638 237.457 142.574 237.457C94.5108 237.457 55.5475 236.528 55.5475 235.382C55.5475 234.237 94.5108 233.308 142.574 233.308C190.638 233.308 229.601 234.237 229.601 235.382Z"
        fill="url(#paint2_radial_11_4729)"
      />
      <path
        d="M195.784 188.206C195.418 190.04 197.618 190.407 197.985 192.974C198.352 195.542 197.251 196.276 197.618 197.743C197.985 199.21 200.186 199.577 200.552 203.245C200.919 206.912 199.452 206.546 199.819 208.746C200.185 210.947 202.386 210.947 202.753 212.781C203.119 214.615 203.119 217.183 203.853 219.383C204.587 221.584 206.787 224.884 207.888 224.884C208.988 224.884 211.922 218.649 211.189 216.815C210.455 214.981 209.355 214.614 209.355 213.147C209.355 211.68 210.822 208.012 210.455 205.445C210.088 202.877 206.787 201.777 206.42 199.943C206.053 198.109 207.154 193.341 204.586 191.14C202.02 188.94 196.151 186.373 195.784 188.206Z"
        fill="#3FB790"
      />
      <path
        d="M207.719 224.255C207.618 224.255 207.536 224.174 207.536 224.073C207.536 224.025 207.505 219.259 206.108 217.862C204.691 216.445 203.882 212.109 203.487 203.803C203.127 196.257 197.718 190.04 197.663 189.978C197.596 189.902 197.604 189.786 197.679 189.719C197.756 189.652 197.872 189.659 197.938 189.735C197.994 189.798 203.487 196.108 203.852 203.785C204.238 211.882 205.037 216.273 206.367 217.602C207.87 219.105 207.902 223.869 207.903 224.071C207.903 224.172 207.821 224.255 207.72 224.255H207.719Z"
        fill="#34916F"
      />
      <path
        d="M229.358 193.757C230.655 195.054 226.424 195.592 226.056 198.159C225.69 200.726 225.69 201.827 224.223 203.294C222.756 204.761 220.555 205.128 220.922 207.328C221.288 209.529 222.022 211.73 220.922 212.83C219.821 213.93 217.254 213.93 216.52 215.764C215.786 217.597 216.153 219.798 214.686 221.632C213.219 223.467 211.018 227.134 209.184 226.401C207.351 225.667 208.451 217.231 209.184 215.764C209.918 214.297 210.651 213.196 210.651 212.096C210.651 210.996 210.285 209.162 211.019 207.328C211.752 205.494 215.787 204.76 216.153 203.66C216.52 202.56 216.887 196.691 219.087 195.224C221.288 193.757 227.157 191.557 229.358 193.757Z"
        fill="#4FC7A0"
      />
      <path
        d="M209.754 225.772C209.722 225.772 209.689 225.763 209.659 225.746C209.573 225.693 209.545 225.581 209.597 225.494C209.611 225.469 211.081 223.013 211.391 221.772C211.471 221.452 211.567 220.967 211.679 220.406C212.084 218.37 212.696 215.293 213.64 214.35C215.008 212.982 217.195 208.79 218.728 203.426C220.616 196.818 226.858 194.883 226.921 194.865C227.02 194.836 227.12 194.891 227.149 194.988C227.178 195.085 227.123 195.187 227.026 195.216C226.965 195.235 220.912 197.116 219.08 203.527C217.531 208.95 215.301 213.207 213.899 214.609C213.035 215.473 212.411 218.606 212.038 220.477C211.925 221.043 211.828 221.531 211.747 221.86C211.424 223.154 209.972 225.579 209.911 225.682C209.877 225.74 209.816 225.772 209.754 225.772Z"
        fill="#3FB690"
      />
      <path
        d="M209.285 197.957C204.883 198.324 206.351 211.528 206.351 211.528C207.451 222.898 208.918 228.033 210.019 228.4C211.119 228.767 213.32 212.262 213.32 208.227C213.32 208.227 213.686 197.591 209.285 197.957Z"
        fill="#90DAD8"
      />
      <path
        d="M209.835 226.566C209.827 226.566 209.82 226.565 209.812 226.564C209.712 226.552 209.64 226.46 209.653 226.36C211.1 214.417 209.304 199.413 209.286 199.262C209.274 199.162 209.345 199.071 209.446 199.058C209.543 199.043 209.637 199.117 209.65 199.218C209.669 199.369 211.47 214.417 210.017 226.404C210.006 226.498 209.926 226.566 209.835 226.566Z"
        fill="white"
      />
      <path
        d="M215.301 234.915H204.14C203.767 234.915 203.453 234.688 203.411 234.388L201.789 222.816C201.716 222.295 202.121 221.83 202.647 221.83H216.794C217.32 221.83 217.724 222.295 217.651 222.816L216.03 234.388C215.987 234.688 215.674 234.915 215.301 234.915Z"
        fill="#D0DAED"
      />
      <path
        d="M70.6161 112.737C70.6161 112.737 67.4608 110.072 67.226 110.243C66.9917 110.413 67.3541 111.927 67.3541 111.927C67.3541 111.927 65.2219 110.328 64.3051 111.224C63.3882 112.119 66.1175 118.089 68.8037 118.814L70.6161 112.737Z"
        fill="#FFAA9D"
      />
      <path
        d="M177.802 109.663C177.802 109.663 180.957 106.998 181.192 107.169C181.426 107.339 181.064 108.853 181.064 108.853C181.064 108.853 183.196 107.254 184.113 108.149C185.03 109.045 182.3 115.015 179.614 115.74L177.802 109.663Z"
        fill="#FFAA9D"
      />
      <path
        d="M102.288 225.232V230.049H118.777L119.376 224.489L102.288 225.232Z"
        fill="url(#paint3_linear_11_4729)"
      />
      <path
        d="M102.288 230.049L99.2079 233.533C98.9485 233.826 98.9447 234.211 99.1109 234.501C99.2495 234.741 99.5055 234.916 99.8311 234.916H117.61C117.772 234.916 117.921 234.856 118.034 234.756C118.148 234.655 118.226 234.515 118.246 234.355L118.777 230.05H102.288V230.049Z"
        fill="#0B2252"
      />
      <path
        d="M147.729 225.212L148.203 230.049H131.714L130.888 224.48L147.729 225.212Z"
        fill="url(#paint4_linear_11_4729)"
      />
      <path
        d="M148.202 230.049L151.282 233.533C151.542 233.826 151.545 234.211 151.379 234.501C151.241 234.741 150.985 234.916 150.659 234.916H132.88C132.718 234.916 132.569 234.856 132.456 234.756C132.342 234.655 132.264 234.515 132.244 234.355L131.713 230.05H148.202V230.049Z"
        fill="#0B2252"
      />
      <path
        d="M110.57 141.152C110.57 141.152 104.256 162.666 103.087 179.035C101.918 195.405 101.969 225.775 101.969 225.775H119.587C119.587 225.775 123.707 184.299 125.342 184.15C126.977 184.001 130.248 225.775 130.248 225.775H148.682C148.682 225.775 144.531 154.36 137.95 141.152L110.57 141.152Z"
        fill="#14336D"
      />
      <path
        d="M181.802 114.865L177.791 109.004C170.797 113.014 160.924 113.22 148.891 109.93C140.084 107.52 133.932 104.892 124.083 104.892C114.233 104.892 104.555 111.859 99.6531 113.199C87.6203 116.49 77.7467 116.285 70.7531 112.273L66.7423 118.135C66.7423 118.135 83.1554 131.977 107.42 128.258C106.822 136.401 105.478 148.853 105.892 150.774C106.863 155.282 140.68 155.487 142.319 150.353C142.8 148.847 140.53 133.052 140.191 124.84C164.967 129.067 181.802 114.865 181.802 114.865Z"
        fill="url(#paint5_linear_11_4729)"
      />
      <path
        d="M133.01 97.2476L133.086 102.324L132.328 102.3C132.328 102.3 131.72 106.502 128.754 105.839C127.901 105.648 126.813 104.927 126.5 105.071C126.128 105.242 125.967 106.392 125.883 106.724C125.561 107.996 121.109 106.711 121.83 105.407C122.515 104.17 123.537 102.48 123.321 102.011C122.566 100.374 122.352 96.3105 126.443 94.9521C129.703 93.8701 132.974 95.51 133.01 97.2476Z"
        fill="#FFAA9D"
      />
      <path
        d="M121.831 105.407C122.516 104.17 123.537 102.48 123.321 102.011C123.321 102.011 125.039 104.654 126.624 105.053C126.628 105.054 126.629 105.056 126.633 105.057C126.581 105.054 126.534 105.055 126.5 105.071C126.128 105.242 125.968 106.392 125.883 106.724C125.56 107.996 121.109 106.711 121.831 105.407Z"
        fill="#FF9F91"
      />
      <path
        d="M126.145 99.7377C124.233 99.4111 125.421 103.671 123.314 103.529C121.208 103.387 119.739 98.7822 121.285 95.2313C122.832 91.6804 125.772 91.878 128.574 92.362C131.376 92.8465 134.812 94.1135 134.809 96.2327C134.804 101.332 128.77 97.0538 128.371 98.587C128.063 99.7729 127.588 103.203 128.818 103.282C130.047 103.361 131.299 102.347 132.27 102.607C132.83 102.757 134.368 109.445 130.347 109.669C126.368 109.89 125.361 106.378 126.2 103.51C126.997 100.782 127.078 99.8971 126.145 99.7377Z"
        fill="#14336A"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11_4729"
          x1="132.759"
          y1="238.92"
          x2="132.759"
          y2="-25.5587"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEFEFD" />
          <stop offset="1" stop-color="#EBF3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11_4729"
          x1="132.759"
          y1="228.675"
          x2="132.759"
          y2="153.053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEFEFD" />
          <stop offset="0.8395" stop-color="#EBF3FF" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_11_4729"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(142.574 235.382) scale(90.1659 91.7315)"
        >
          <stop stop-color="#D0DFF3" />
          <stop offset="0.9872" stop-color="#D0DFF3" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_11_4729"
          x1="102.288"
          y1="227.269"
          x2="119.377"
          y2="227.269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFAA9D" />
          <stop offset="0.9662" stop-color="#FF9F91" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11_4729"
          x1="148.203"
          y1="227.264"
          x2="130.888"
          y2="227.264"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFAA9D" />
          <stop offset="0.9662" stop-color="#FF9F91" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11_4729"
          x1="164.12"
          y1="122.059"
          x2="145.543"
          y2="179.143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#03B7ED" />
          <stop offset="0.9649" stop-color="#173DB8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const rejectedSvg = () => {
  return (
    <svg
      width="265"
      height="276"
      viewBox="0 0 265 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M132.5 275.065C205.678 275.065 265 215.742 265 142.565C265 69.387 205.678 10.0647 132.5 10.0647C59.3223 10.0647 0 69.387 0 142.565C0 215.742 59.3223 275.065 132.5 275.065Z"
        fill="url(#paint0_linear_11_4577)"
      />
      <path
        d="M264.303 159.411C249.701 153.032 230.689 149.977 218.814 154.427C207.673 158.602 209.465 166.889 198.03 170.313C179.58 175.838 166.799 156.696 139.344 157.604C114.917 158.412 106.449 174.18 87.9952 170.313C76.4861 167.901 74.3066 160.621 66.1139 155.486C52.3852 146.882 26.0332 146.972 0.695679 151.894C3.00292 185.05 17.5056 214.843 39.7518 236.82C64.7752 241.449 92.0008 243.921 118.56 242.935C165.232 241.203 212.436 228.704 244.588 213.821C254.879 197.722 261.785 179.252 264.303 159.411Z"
        fill="url(#paint1_linear_11_4577)"
      />
      <path
        d="M106.054 73.5044C104.081 71.5316 101.356 70.3114 98.3455 70.3114H87.4986C85.883 62.8834 79.2782 57.3174 71.3662 57.3174C63.4543 57.3174 56.8496 62.8834 55.234 70.3114H52.3155C49.305 70.3114 46.5795 71.5316 44.6067 73.5044C42.634 75.4772 41.4138 78.2026 41.4138 81.2131C41.4138 84.543 42.9069 87.5244 45.2597 89.5239C47.1613 91.1399 49.6244 92.1147 52.3155 92.1147H98.3455C101.356 92.1147 104.081 90.8945 106.054 88.9217C108.027 86.949 109.247 84.2236 109.247 81.2131C109.247 78.2026 108.027 75.4772 106.054 73.5044Z"
        fill="#D8E2F4"
      />
      <path
        d="M206.196 43.3151H159.176C156.101 43.3151 153.317 42.0688 151.301 40.0534C149.286 38.038 148.04 35.254 148.04 32.1791C148.04 29.9861 148.673 27.9417 149.768 26.2182C151.743 23.1075 155.218 21.0432 159.176 21.0432H206.195C209.27 21.0432 212.054 22.2895 214.07 24.3049C216.085 26.3203 217.331 29.1043 217.331 32.1791C217.331 35.0478 216.247 37.6634 214.465 39.6376C212.427 41.896 209.477 43.3151 206.196 43.3151Z"
        fill="white"
      />
      <path
        d="M190.559 36.5765C197.148 29.9873 197.148 19.3042 190.559 12.715C183.97 6.12581 173.287 6.12583 166.698 12.715C160.108 19.3042 160.108 29.9873 166.698 36.5765C173.287 43.1657 183.97 43.1657 190.559 36.5765Z"
        fill="white"
      />
      <path
        d="M196.253 245.193C196.253 246.341 164.094 247.271 124.424 247.271C84.7544 247.271 52.5953 246.341 52.5953 245.193C52.5953 244.044 84.7544 243.114 124.424 243.114C164.094 243.114 196.253 244.044 196.253 245.193Z"
        fill="url(#paint2_radial_11_4577)"
      />
      <path
        d="M169.591 145.284C169.495 145.641 169.365 146.119 169.211 146.673C169.171 146.814 169.131 146.959 169.089 147.109C169.069 147.178 169.049 147.247 169.029 147.318C169.004 147.403 168.98 147.489 168.955 147.576C168.845 147.961 168.726 148.367 168.602 148.783C168.577 148.866 168.551 148.951 168.526 149.037C168.508 149.095 168.491 149.153 168.473 149.211C168.427 149.361 168.381 149.513 168.333 149.665C168.277 149.848 168.22 150.032 168.162 150.215C168.135 150.299 168.108 150.383 168.081 150.466C167.956 150.857 167.828 151.245 167.699 151.62C167.617 151.859 167.535 152.093 167.453 152.32C167.363 152.568 167.274 152.808 167.184 153.036C167.153 153.117 167.122 153.197 167.09 153.275C166.926 153.685 166.764 154.051 166.61 154.355C166.571 154.432 166.533 154.505 166.494 154.574C166.246 155.023 166.02 155.289 165.833 155.289C165.632 155.289 165.386 154.98 165.115 154.469C165.078 154.398 165.04 154.324 165.002 154.247C164.851 153.936 164.692 153.568 164.53 153.16C164.5 153.082 164.468 153.002 164.437 152.92C164.391 152.802 164.346 152.681 164.3 152.558C164.242 152.399 164.183 152.236 164.125 152.07C164.086 151.961 164.047 151.85 164.008 151.739C163.979 151.658 163.951 151.575 163.923 151.492C163.795 151.112 163.666 150.721 163.541 150.327C163.514 150.244 163.488 150.16 163.461 150.076C163.441 150.012 163.421 149.948 163.401 149.885C163.354 149.732 163.307 149.581 163.26 149.43C163.205 149.25 163.151 149.071 163.098 148.893C163.072 148.808 163.047 148.723 163.022 148.638C162.899 148.225 162.782 147.823 162.673 147.443C162.619 147.255 162.568 147.073 162.519 146.898C162.336 146.248 162.183 145.688 162.075 145.284C162.051 145.194 162.05 145.104 162.07 145.02C162.088 144.938 162.127 144.861 162.18 144.796C162.279 144.675 162.43 144.595 162.604 144.595H169.062C169.178 144.595 169.284 144.63 169.371 144.69C169.438 144.736 169.494 144.796 169.534 144.865C169.605 144.986 169.631 145.134 169.591 145.284Z"
        fill="url(#paint3_linear_11_4577)"
      />
      <path
        opacity="0.7"
        d="M167.935 146.321L169.533 144.865C169.493 144.796 169.437 144.736 169.37 144.689L167.757 146.159L166.926 145.403L167.813 144.595H167.457L166.749 145.241L166.04 144.595H165.441L164.712 145.259L163.979 144.595H163.622L164.534 145.421L163.704 146.178L162.179 144.796C162.127 144.861 162.088 144.938 162.069 145.02L163.526 146.34L162.716 147.078L162.518 146.898C162.567 147.073 162.619 147.255 162.672 147.443L162.716 147.403L163.546 148.159L163.021 148.638C163.046 148.723 163.071 148.808 163.096 148.893L163.724 148.322L164.554 149.078L163.712 149.845L163.259 149.429C163.306 149.58 163.353 149.732 163.4 149.884L163.535 150.008L163.46 150.075C163.487 150.159 163.513 150.243 163.54 150.327L163.711 150.17L164.538 150.93L163.922 151.491C163.95 151.574 163.978 151.657 164.007 151.738L164.715 151.093L165.57 151.877L164.743 152.638L164.124 152.069C164.182 152.235 164.241 152.398 164.3 152.557L164.565 152.801L164.437 152.919C164.468 153.001 164.5 153.081 164.53 153.159L164.743 152.964L165.57 153.724L165.002 154.246C165.04 154.323 165.078 154.397 165.115 154.468L165.747 153.887L166.494 154.573C166.532 154.504 166.571 154.431 166.61 154.354L165.925 153.724L166.752 152.964L167.089 153.275C167.121 153.197 167.152 153.117 167.184 153.036L166.928 152.801L167.453 152.319C167.535 152.092 167.617 151.858 167.699 151.619L166.95 150.936L167.769 150.182L168.081 150.464C168.108 150.381 168.134 150.298 168.162 150.214L167.946 150.019L168.333 149.663C168.38 149.512 168.426 149.36 168.473 149.209L167.768 149.857L166.917 149.086L167.747 148.33L168.526 149.035C168.551 148.95 168.576 148.865 168.602 148.781L167.925 148.168L168.766 147.402L168.955 147.574C168.98 147.487 169.005 147.401 169.028 147.317L168.943 147.239L169.088 147.107C169.131 146.957 169.171 146.811 169.211 146.671L168.766 147.077L167.935 146.321ZM167.579 146.322L166.735 147.091L165.902 146.337L166.749 145.565L167.579 146.322ZM165.727 148.01L164.894 147.256L165.724 146.499L166.556 147.254L165.727 148.01ZM165.728 148.334L166.56 149.088L165.741 149.835L164.911 149.078L165.728 148.334ZM165.741 144.646L166.571 145.403L165.723 146.175L164.891 145.421L165.741 144.646ZM164.713 145.583L165.545 146.338L164.715 147.094L163.882 146.34L164.713 145.583ZM162.894 147.241L163.704 146.502L164.538 147.256L163.724 147.998L162.894 147.241ZM163.902 148.16L164.716 147.418L165.548 148.172L164.732 148.917L163.902 148.16ZM163.889 150.009L164.732 149.241L165.562 149.997L164.715 150.769L163.889 150.009ZM164.894 150.932L165.741 150.16L166.593 150.937L165.746 151.716L164.894 150.932ZM165.746 153.563L164.919 152.802L165.746 152.042L166.574 152.802L165.746 153.563ZM167.603 151.856L166.751 152.64L165.924 151.879L166.772 151.099L167.603 151.856ZM167.59 150.022L166.771 150.775L165.919 149.998L166.739 149.251L167.59 150.022ZM166.738 148.926L165.906 148.172L166.735 147.415L167.568 148.17L166.738 148.926ZM167.746 148.007L166.913 147.253L167.757 146.484L168.588 147.241L167.746 148.007Z"
        fill="#E88207"
      />
      <path
        d="M129.376 234.744L128.477 239.632H144.553L146.43 234.744H129.376Z"
        fill="#FFAA9D"
      />
      <path
        d="M144.553 239.632H128.051L127.291 244.724H149.541L144.553 239.632Z"
        fill="#0B2252"
      />
      <path
        d="M128.476 234.744C128.476 234.744 131.345 210.831 131.449 208.964C131.552 207.097 131.624 200.873 128.476 198.28C125.328 195.687 117.891 186.059 116.927 177.304C115.963 168.548 116.927 153.88 116.927 153.88H137.004C137.004 153.88 152.443 178.155 152.443 192.156C152.443 209.897 149.162 233.187 148.233 234.744H128.476Z"
        fill="url(#paint4_linear_11_4577)"
      />
      <path
        d="M110.942 153.88L96.6147 234.744H115.417L139.531 160.395L110.942 153.88Z"
        fill="#14336D"
      />
      <path
        d="M112.666 239.632H96.5902L95.3879 244.724H115.778L112.666 239.632Z"
        fill="#0B2252"
      />
      <path
        d="M97.4899 234.744L96.5906 239.632H112.667L114.544 234.744H97.4899Z"
        fill="#FFAA9D"
      />
      <path
        d="M164.124 152.073C164.148 152.146 164.172 152.213 164.202 152.281C161.501 152.678 156.796 152.688 156.796 152.688C156.39 151.826 158.297 146.73 158.766 147.277C159.105 147.678 161.346 147.238 162.604 147.199C163.069 147.18 163.757 146.828 163.883 147.255C164.008 147.681 163.006 148.395 163.094 148.874C163.099 148.903 163.108 148.932 163.118 148.961C163.166 149.116 163.21 149.275 163.258 149.43C163.307 149.58 163.355 149.73 163.399 149.885C163.423 149.948 163.442 150.011 163.462 150.074C163.486 150.161 163.515 150.244 163.539 150.326C163.665 150.723 163.795 151.11 163.921 151.492C163.95 151.575 163.979 151.657 164.008 151.739C164.047 151.85 164.085 151.962 164.124 152.073Z"
        fill="#FFAA9D"
      />
      <path
        d="M130.812 118.376C131.815 120.51 132.618 140.814 134.257 141.95C135.897 143.086 157.849 146.601 158.542 146.865C159.235 147.129 159.723 152.517 159.394 152.959C159.064 153.402 134.073 160.201 122.983 152.496C111.893 144.792 119.346 122.062 119.862 120.957C123.663 112.808 129.809 116.242 130.812 118.376Z"
        fill="url(#paint5_linear_11_4577)"
      />
      <path
        d="M115.028 120.331C115.028 120.331 108.059 157.111 109.097 159.118C112.601 165.891 143.81 164.387 142.535 160.788C139.049 150.955 139.671 124.289 136.242 119.732C133.067 115.512 128.727 114.99 125.056 114.989C117.198 114.989 115.643 116.73 115.028 120.331Z"
        fill="url(#paint6_linear_11_4577)"
      />
      <path
        d="M137.188 111.7L135.327 116.435L134.634 116.125C134.634 116.125 132.472 119.788 129.974 118.045C129.256 117.544 128.523 116.462 128.178 116.476C127.767 116.493 127.181 117.498 126.977 117.773C126.194 118.829 122.556 115.945 123.721 115.011C124.827 114.125 126.417 112.947 126.395 112.429C126.319 110.626 127.666 106.777 131.975 107.074C135.407 107.312 137.815 110.076 137.188 111.7Z"
        fill="#FFAA9D"
      />
      <path
        d="M123.721 115.011C124.827 114.125 126.417 112.947 126.395 112.429C126.395 112.429 126.983 115.532 128.3 116.506C128.302 116.508 128.303 116.511 128.306 116.512C128.26 116.49 128.216 116.474 128.178 116.475C127.768 116.492 127.182 117.497 126.977 117.773C126.194 118.829 122.556 115.945 123.721 115.011Z"
        fill="#FF9F91"
      />
      <path
        d="M129.876 111.397C128.228 110.367 127.708 114.768 125.809 113.835C123.91 112.901 124.302 108.074 127.086 105.371C129.87 102.667 132.52 103.969 134.934 105.484C137.347 106.999 140.049 109.48 139.241 111.444C137.297 116.169 133.331 109.908 132.378 111.177C131.64 112.159 129.896 115.158 131.005 115.699C132.115 116.24 133.661 115.776 134.462 116.387C134.924 116.739 133.805 123.523 129.993 122.201C126.221 120.892 126.624 117.254 128.492 114.914C130.269 112.689 130.68 111.9 129.876 111.397Z"
        fill="#14336A"
      />
      <path
        d="M122.603 156.152C122.603 156.152 128.632 161.375 128.516 161.615C128.401 161.855 126.974 161.775 126.974 161.775C126.974 161.775 128.767 163.44 128.107 164.414C127.448 165.388 120.045 162.369 118.952 160.06L122.603 156.152Z"
        fill="#FFAA9D"
      />
      <path
        d="M124.903 157.276L120.188 162.208C120.188 162.208 106.363 156.649 104.714 143.031C103.064 129.414 109.203 116.999 117.787 116.471C124.572 116.054 120.564 128.267 118.889 132.705C117.215 137.143 114.688 145.572 124.903 157.276Z"
        fill="url(#paint7_linear_11_4577)"
      />
      <path
        d="M50.7571 197.924C50.3897 199.761 52.5948 200.129 52.9622 202.701C53.3295 205.274 52.227 206.009 52.5948 207.479C52.9622 208.949 55.1673 209.316 55.5346 212.991C55.902 216.667 54.4321 216.299 54.7995 218.504C55.1668 220.709 57.3719 220.709 57.7393 222.547C58.1066 224.384 58.1066 226.957 58.8418 229.162C59.577 231.367 61.7817 234.674 62.8842 234.674C63.9868 234.674 66.9266 228.426 66.1919 226.589C65.4567 224.751 64.3541 224.383 64.3541 222.914C64.3541 221.444 65.824 217.769 65.4567 215.196C65.0893 212.624 61.7817 211.521 61.4143 209.683C61.047 207.846 62.1495 203.068 59.5766 200.863C57.0046 198.659 51.1249 196.086 50.7571 197.924Z"
        fill="#3FB790"
      />
      <path
        d="M62.7166 234.044C62.6155 234.044 62.5332 233.962 62.5327 233.861C62.5327 233.813 62.5013 229.037 61.1016 227.638C59.682 226.218 58.8717 221.873 58.4754 213.551C58.1153 205.99 52.6954 199.761 52.6407 199.699C52.5734 199.623 52.5807 199.507 52.6567 199.439C52.7336 199.372 52.8493 199.379 52.9161 199.456C52.9717 199.519 58.4758 205.841 58.8417 213.533C59.2284 221.646 60.0285 226.045 61.3609 227.377C62.8671 228.884 62.8991 233.656 62.9001 233.859C62.9006 233.96 62.8178 234.043 62.7166 234.044Z"
        fill="#34916F"
      />
      <path
        d="M84.3968 203.486C85.6963 204.785 81.4569 205.323 81.0891 207.896C80.7217 210.468 80.7217 211.571 79.2513 213.041C77.7814 214.511 75.5763 214.879 75.9436 217.083C76.311 219.288 77.0462 221.493 75.9436 222.595C74.8411 223.698 72.2686 223.698 71.5334 225.535C70.7982 227.373 71.1661 229.578 69.6957 231.415C68.2253 233.253 66.0206 236.928 64.1829 236.193C62.3451 235.458 63.4477 227.006 64.1829 225.535C64.9181 224.065 65.6528 222.963 65.6528 221.86C65.6528 220.758 65.2854 218.92 66.0202 217.083C66.7554 215.245 70.7977 214.51 71.1651 213.408C71.5325 212.305 71.9003 206.425 74.1049 204.955C76.3115 203.486 82.1917 201.281 84.3968 203.486Z"
        fill="#4FC7A0"
      />
      <path
        d="M64.7539 235.563C64.7215 235.563 64.6891 235.555 64.659 235.537C64.5724 235.485 64.5439 235.372 64.5961 235.285C64.6106 235.26 66.083 232.799 66.3937 231.555C66.4736 231.235 66.5708 230.749 66.6821 230.187C67.0882 228.147 67.702 225.064 68.6472 224.119C70.0184 222.748 72.21 218.548 73.7457 213.174C75.6377 206.552 81.8919 204.614 81.9549 204.596C82.0541 204.566 82.1548 204.622 82.1833 204.719C82.2124 204.816 82.1577 204.918 82.0604 204.947C81.9994 204.966 75.9344 206.851 74.099 213.274C72.5464 218.709 70.3122 222.974 68.9071 224.379C68.0412 225.245 67.4164 228.383 67.0433 230.258C66.93 230.825 66.8332 231.314 66.7509 231.644C66.4266 232.941 64.9732 235.37 64.9117 235.473C64.8773 235.531 64.8159 235.563 64.7539 235.563Z"
        fill="#3FB690"
      />
      <path
        d="M64.2842 207.694C59.874 208.061 61.3443 221.291 61.3443 221.291C62.4469 232.684 63.9168 237.829 65.0194 238.196C66.1219 238.564 68.327 222.026 68.327 217.984C68.327 217.984 68.6944 207.326 64.2842 207.694Z"
        fill="#90DAD8"
      />
      <path
        d="M64.8356 236.359C64.8278 236.359 64.8206 236.358 64.8128 236.357C64.7121 236.344 64.6405 236.253 64.6526 236.152C66.1027 224.185 64.3037 209.152 64.2853 209.001C64.2732 208.901 64.3444 208.809 64.4455 208.797C64.5433 208.782 64.6376 208.856 64.6502 208.957C64.6691 209.108 66.474 224.185 65.0176 236.196C65.006 236.29 64.927 236.359 64.8356 236.359Z"
        fill="white"
      />
      <path
        d="M70.3131 244.725H59.1303C58.7566 244.725 58.442 244.497 58.3999 244.196L56.7751 232.601C56.7021 232.08 57.1071 231.614 57.6342 231.614H71.8092C72.3363 231.614 72.7414 232.08 72.6683 232.601L71.0435 244.196C71.0014 244.497 70.6868 244.725 70.3131 244.725Z"
        fill="#D0DAED"
      />
      <path
        d="M186.039 243.275C185.759 243.198 185.589 242.924 185.626 242.636C185.642 242.512 185.651 242.386 185.651 242.258C185.651 240.435 184.049 238.957 182.072 238.957C180.095 238.957 178.493 240.435 178.493 242.258C178.493 242.398 178.503 242.535 178.522 242.67C178.56 242.944 178.406 243.207 178.144 243.298C177.194 243.626 175.704 244.225 175.788 244.728C175.879 245.274 177.662 245.13 178.573 245.019C178.816 244.989 179.01 245.214 178.947 245.451C178.78 246.077 178.6 247.083 179.1 247.25C179.694 247.448 181.222 246.224 181.788 245.745C181.914 245.639 182.095 245.636 182.224 245.737C182.869 246.243 184.744 247.627 185.316 247.1C185.709 246.738 185.29 246.095 184.852 245.606C184.645 245.375 184.825 245.01 185.135 245.032C186.475 245.131 188.746 245.213 188.832 244.647C188.907 244.164 187.319 243.627 186.039 243.275Z"
        fill="#50C6A1"
      />
      <path
        d="M184.7 238.624C184.695 238.624 184.691 238.624 184.687 238.624C184.553 238.617 184.451 238.503 184.458 238.37L184.547 236.715C184.553 236.582 184.673 236.483 184.801 236.486C184.934 236.493 185.036 236.607 185.03 236.741L184.941 238.396C184.934 238.525 184.827 238.624 184.7 238.624Z"
        fill="#50C6A1"
      />
      <path
        d="M188.332 241.024C188.327 241.024 188.323 241.024 188.319 241.024L186.664 240.936C186.53 240.929 186.428 240.815 186.435 240.681C186.442 240.548 186.561 240.445 186.689 240.452L188.344 240.541C188.478 240.548 188.58 240.662 188.573 240.795C188.567 240.925 188.46 241.024 188.332 241.024Z"
        fill="#50C6A1"
      />
      <path
        d="M186.268 239.178C186.201 239.178 186.136 239.151 186.088 239.098C185.998 238.999 186.006 238.845 186.106 238.756L187.339 237.649C187.438 237.559 187.591 237.567 187.681 237.667C187.77 237.766 187.762 237.92 187.662 238.009L186.429 239.117C186.383 239.158 186.325 239.178 186.268 239.178Z"
        fill="#50C6A1"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11_4577"
          x1="132.5"
          y1="248.738"
          x2="132.5"
          y2="-16.2611"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEFEFD" />
          <stop offset="1" stop-color="#EBF3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11_4577"
          x1="132.5"
          y1="238.472"
          x2="132.5"
          y2="162.701"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEFEFD" />
          <stop offset="0.8395" stop-color="#EBF3FF" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_11_4577"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(124.424 245.193) scale(74.4196 91.9138)"
        >
          <stop stop-color="#D0DFF3" />
          <stop offset="0.9872" stop-color="#D0DFF3" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_11_4577"
          x1="165.833"
          y1="155.156"
          x2="165.833"
          y2="148.598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8E00" />
          <stop offset="1" stop-color="#FFCF01" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11_4577"
          x1="152.295"
          y1="218.545"
          x2="129.723"
          y2="190.573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#14336D" />
          <stop offset="0.9662" stop-color="#0E2253" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11_4577"
          x1="123.489"
          y1="126.418"
          x2="150.21"
          y2="163.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0351" stop-color="#173DB8" />
          <stop offset="1" stop-color="#03B7ED" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_11_4577"
          x1="137.412"
          y1="132.006"
          x2="106.281"
          y2="160.172"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#03B7ED" />
          <stop offset="0.9649" stop-color="#173DB8" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_11_4577"
          x1="121.749"
          y1="134.988"
          x2="100.103"
          y2="156.024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#03B7ED" />
          <stop offset="0.9649" stop-color="#03A7D9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const noLocationSvg = () => {
  return (
    <svg
      width="178"
      height="205"
      viewBox="0 0 178 205"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M119.693 70.1601C107.138 70.1601 94.3891 69.6508 82.4483 66.3247C70.7323 63.0737 59.9752 56.7661 50.3868 49.47C44.0945 44.7208 38.4014 40.9453 30.2361 41.5144C22.2653 41.9364 14.6424 44.9153 8.49726 50.0091C-1.88517 59.0881 -0.312253 75.8681 3.8228 87.6889C10.0702 105.442 29.0974 117.788 45.1581 125.848C63.7805 135.152 84.2312 140.575 104.756 143.661C122.735 146.388 145.822 148.381 161.403 136.635C175.726 125.848 179.651 101.217 176.145 84.5724C175.286 79.6593 172.665 75.2279 168.774 72.1074C158.721 64.7511 143.725 69.6653 132.428 69.92C128.233 70.0103 123.978 70.1601 119.693 70.1601Z"
        fill="#EBF3FF"
      />
      <path
        d="M88.9949 172.801C119.369 172.801 143.994 171.266 143.994 169.371C143.994 167.475 119.369 165.94 88.9949 165.94C58.6198 165.94 33.9961 167.475 33.9961 169.371C33.9961 171.266 58.6198 172.801 88.9949 172.801Z"
        fill="#14336D"
      />
      <path
        d="M117.177 2.93614C117.987 2.93614 118.645 2.27887 118.645 1.46807C118.645 0.657265 117.987 0 117.177 0C116.367 0 115.709 0.657265 115.709 1.46807C115.709 2.2785 116.367 2.93614 117.177 2.93614Z"
        fill="#4A5059"
      />
      <path
        d="M50.0716 145.444C50.8824 145.444 51.5397 144.787 51.5397 143.976C51.5397 143.166 50.8824 142.508 50.0716 142.508C49.2608 142.508 48.6035 143.166 48.6035 143.976C48.6031 144.787 49.2604 145.444 50.0716 145.444Z"
        fill="#4A5059"
      />
      <path
        d="M134.48 152.936V159.393"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M131.244 156.156H137.701"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M86.6272 8.47937C70.7331 8.47937 55.4903 14.7933 44.2517 26.0319C33.0131 37.2705 26.6992 52.5132 26.6992 68.4073C26.6992 112.394 86.6272 153.595 86.6272 153.595C86.6272 153.595 146.555 113.039 146.555 68.4073C146.555 52.5132 140.242 37.2705 129.002 26.0319C117.764 14.7933 102.521 8.47937 86.6272 8.47937ZM86.6272 90.88C81.9575 90.883 77.3916 89.5019 73.5064 86.9115C69.6208 84.3211 66.5906 80.6374 64.7972 76.3257C63.0039 72.0141 62.5288 67.2679 63.4318 62.686C64.3344 58.1045 66.5746 53.8928 69.8691 50.5838C73.1636 47.2744 77.3652 45.0156 81.9427 44.0926C86.5201 43.1695 91.2686 43.6238 95.5884 45.3978C99.9078 47.1718 103.605 50.186 106.213 54.0601C108.82 57.9338 110.221 62.4938 110.239 67.1634C110.245 70.2687 109.639 73.3446 108.455 76.2153C107.272 79.086 105.534 81.6954 103.341 83.8936C101.148 86.0922 98.5431 87.8368 95.6754 89.0279C92.8076 90.219 89.7332 90.8332 86.6279 90.835V90.88H86.6272Z"
        fill="#14336D"
      />
      <path
        d="M86.6272 8.47937C70.7331 8.47937 55.4903 14.7933 44.2517 26.0319C33.0131 37.2705 26.6992 52.5132 26.6992 68.4073C26.6992 112.394 86.6272 153.595 86.6272 153.595C86.6272 153.595 146.555 113.039 146.555 68.4073C146.555 52.5132 140.242 37.2705 129.002 26.0319C117.764 14.7933 102.521 8.47937 86.6272 8.47937ZM86.6272 90.88C81.9575 90.883 77.3916 89.5019 73.5064 86.9115C69.6208 84.3211 66.5906 80.6374 64.7972 76.3257C63.0039 72.0141 62.5288 67.2679 63.4318 62.686C64.3344 58.1045 66.5746 53.8928 69.8691 50.5838C73.1636 47.2744 77.3652 45.0156 81.9427 44.0926C86.5201 43.1695 91.2686 43.6238 95.5884 45.3978C99.9078 47.1718 103.605 50.186 106.213 54.0601C108.82 57.9338 110.221 62.4938 110.239 67.1634C110.245 70.2687 109.639 73.3446 108.455 76.2153C107.272 79.086 105.534 81.6954 103.341 83.8936C101.148 86.0922 98.5431 87.8368 95.6754 89.0279C92.8076 90.219 89.7332 90.8332 86.6279 90.835V90.88H86.6272Z"
        fill="url(#paint0_linear_1470_341)"
      />
      <path
        d="M23.2246 19.5812V26.0382"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.9883 22.802H26.4453"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M157.344 37.1099V43.552"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M154.107 40.3312H160.564"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M94.5976 58.4591L78.6719 74.3699"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M78.6719 58.4591L94.5976 74.3699"
        stroke="#4A5059"
        stroke-width="1.49818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M89.5213 203.297C89.5213 203.458 89.4889 203.609 89.4239 203.754C89.3588 203.894 89.2715 204.016 89.1618 204.121C89.0569 204.226 88.9294 204.312 88.7796 204.376C88.6346 204.436 88.48 204.466 88.3153 204.466C88.1554 204.466 88.0056 204.436 87.8658 204.376C87.7261 204.312 87.6038 204.226 87.4989 204.121C87.3941 204.016 87.3089 203.893 87.2443 203.754C87.1844 203.609 87.1543 203.458 87.1543 203.297C87.1543 203.133 87.1844 202.98 87.2443 202.841C87.3089 202.695 87.3941 202.571 87.4989 202.466C87.6038 202.357 87.7261 202.271 87.8658 202.211C88.0056 202.147 88.1554 202.114 88.3153 202.114C88.48 202.114 88.635 202.147 88.7796 202.211C88.9294 202.271 89.0569 202.357 89.1618 202.466C89.2715 202.571 89.3588 202.695 89.4239 202.841C89.4886 202.98 89.5213 203.132 89.5213 203.297Z"
        fill="#5F6772"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1470_341"
          x1="128.08"
          y1="67.251"
          x2="69.6688"
          y2="172.091"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3162DF" />
          <stop offset="0.9649" stop-color="#173DB8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const expandIcon = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 5L9 1"
        stroke="#3C3C3C"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const collapseIcon = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5L5 1L1 5"
        stroke="#3C3C3C"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
